<template>
    <div class="g-flex g-row-center">
      <div class="total-width white-bg g-m-t-40">
        <div class="title g-rela g-flex g-row-center g-weight-font g-font-24">
          线上实操考试
        </div>
        <div class="g-flex g-row-center g-m-t-35">
          <div>
            <p class="g-font-20 g-weight-font g-text-center">口腔执业医师资格实操考试</p>
            <div class="g-m-t-26 blue-box">
              <div class="g-flex g-row-center">
                <img src="@/assets/examination/success-icon.png" class="success-icon" alt="">
                <p class="g-m-l-15 green-text g-font-24">交卷成功！</p>
              </div>
              <p class="g-m-t-20 main-text g-font-14">请耐心等待考试结果，在“个人中心”→“我的考试”中可查看考试结果</p>
            </div>
            <div class="g-m-t-30 g-flex g-row-center">
              <div class="btn btn1" @click="toDetail">
                返回考试详情
              </div>
              <div class="btn btn2 g-m-l-30" @click="dialogVisible=true" >
                查看实操视频
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog
          :visible.sync="dialogVisible"
          append-to-body
          width="50%">
        <div class="g-rela">
          <video id="media" height="500px"  width="100%" controls>
            <source :src="videoUrl" type="video/mp4">
          </video>
        </div>
        <div class="g-flex g-row-center g-m-t-30">
          <el-button type="primary" @click="dialogVisible=false">关闭</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
export default {
  name: "online-operation-submit",
  data(){
    return{
      videoUrl:this.$route.params.videoUrl,
      dialogVisible:false
    }
  },
  methods:{
    toDetail(){
      this.$router.push({
        name:'examination-detail',
        query: {
          id:this.$route.params.paperId,
        }
      })
    },
    goPage(name,val){
      this.$router.push({
        name:name,
        query:{
          id:val.paperId,
          isCheck:val.status === 1,//true 查看答卷 false 重新考试
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  .white-bg{
    background: #fff;
    padding-bottom: 80px;
  }

  .title{
    background-image: url("../../assets/course-list/course-title-bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 306px;
    height: 91px;
    color: #fff;
    margin: -20px auto 0 auto;
  }

  .blue-box{
    padding: 30px 176px;
    background: #e9f2ff;
    border: 1px dashed #407aff;
    border-radius: 5px;
  }

  .success-icon{
    width: 44px;
    height: 44px;
  }

  .btn{
    padding: 8px 22px;
    border-radius: 5px;
    cursor: pointer;
  }

  .btn1{
    background: #f6f6f8;
    color: #407aff;

    &:hover{
      background: #407aff;
      color: #fff;
    }
  }

  .btn2{
    background: #407aff;
    color: #fff;

    &:hover{
      background: rgba($color:#407aff, $alpha: 0.8);
      color: #fff;
    }
  }
</style>